import React from 'react';
import homePic from './homePic.png';
import homePicMobile from './homePicMobile.png';
import css from './AboutBannerSection.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const AboutBannerSection = ({ intl }) => {
  const history = useHistory();
  return (
    <div className={css.wrapper}>
      <div className={css.heroLeft}>
        <h1 className={css.title}>{intl.formatMessage({ id: 'CustomAboutUsPage.heading' })}</h1>
      </div>
      <img src={homePic} className={css.housePic} />
      <img src={homePicMobile} className={css.homePicMobile} />
    </div>
  );
};

export default AboutBannerSection;
